import fetch               from '../../../utils/browser-fetch';
import { fetchBundleData } from '../../../client-dux';
import { setUserData }     from '../../../user-dux';
import busyActionFactory   from '../../../busy';
import { addError }        from '../../../errors-dux';
import Errors              from '../../../errors';


/*******************************************************************************
 * Initial state
 */
const initialState = {
    busy: false,
    preActivationLoginAttemptFlag: false,
    warningMessage: null
};


/*******************************************************************************
 * Non-async action types
 */
export const BUSY_ACTIVATE = 'BUSY_ACTIVATE';
export const PRE_ACTIVATION_LOGIN_ATTEMPT = 'PRE_ACTIVATION_LOGIN_ATTEMPT';


/*******************************************************************************
 * Reducer
 */
export default function activationData( state = initialState, action ) {
    switch ( action.type ) {

        case BUSY_ACTIVATE:
            return {
                ...state,
                busy: action.busy
            };

        case PRE_ACTIVATION_LOGIN_ATTEMPT:
            return {
                ...state,
                preActivationLoginAttemptFlag: action.flag,
                warningMessage: action.warningMessage
            };

        default:
            return state;
    }
}


/*******************************************************************************
 * Action creators
 */
export function preActivationLoginAttempt( flag, message ) {
    return {
        type: PRE_ACTIVATION_LOGIN_ATTEMPT,
        flag: flag,
        warningMessage: message
    };
}


const busyActivate = busyActionFactory( BUSY_ACTIVATE );
export function activate( username, password, characteristics ) {
    return ( dispatch, getState ) => {
        const clientLocale = getState().clientData.locale.code;

        dispatch( busyActivate( true ) );

        return fetch( '/api/v1.0/activate', {
                method: 'post',
                body: {
                    'characteristics': characteristics,
                    'password': password,
                    'username': username
                }
            } )
            .then( ( userData ) => {
                if ( !userData.locale.code ) {
                    userData.locale = { ...getState().clientData.locale };
                }

                const userLocale = userData.locale.code;
                const setData = () => {
                    dispatch( busyActivate( false ) );
                    userData.authenticated = true;
                    dispatch( setUserData( userData ) );
                };

                // If the user has a default locale set for them that is different from
                // the default locale for the client, we need to make a request that
                // bundle and set the new locale after they have activated.
                if ( userLocale !== clientLocale ) {
                    dispatch( fetchBundleData( userLocale ) ).then( () => setData() );
                } else {
                    setData();
                }
            } )
            .catch( ( error ) => {
                dispatch( busyActivate( false ) );
                dispatch( addError( error, Errors.ERROR_ACTIVATION_ACTIVATE ) );
            } );
    };
}

